module.exports = __webpack_public_path__ + "static/media/ebay.1958140e.svg";